const environment = {
  apiUrl: "https://api.fipay.io", //"http://localhost:3001",
  graphql: "https://api.fipay.io/graphql", //"http://localhost:3001/graphql", //
  joinWaitlistTempId: "100",
  joinSubscriptionTempId: "100",
  publishableKey:
    "pk_test_51Jpup5Aru3tyqTLafufwWdax7zZHCd9qCUlLxpWh0yk38TYiBsXwUVckOn8EChvvOs8M4rbXilIhaRyfvU0vh9fT00EcOvuDoV",
  accessKeyId: "AKIASYX7YD3NYLHERWWV",
  secretAccessKey: "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",
  googleAPIKEY: "AIzaSyDDVEcBhn_h6DSsugydMYQaNqXrU4ZZdl0",
  stripePublicKey:
    "pk_test_51Jpup5Aru3tyqTLafufwWdax7zZHCd9qCUlLxpWh0yk38TYiBsXwUVckOn8EChvvOs8M4rbXilIhaRyfvU0vh9fT00EcOvuDoV",
  clientId: "401c3b76e3354f2e87a41b8ffbf0a233",
  visaUrl: "https://link.visa.com/1.0/account-check/create-report",
  callbackUrl: "https://fipay.io/callback", //"http://localhost:3000/callback", //
  vapid_pulic_key:
    "BE6deN9hqtgVQMKYlXS6xicuILYomzWQ4E8RP_d_wFDqVAGz3uXl3lwaAqLANtnudr2OqSKLgeeL6XIHIorUd28",

  // stripePublicKey:
  //   "pk_test_51Jpup5Aru3tyqTLafufwWdax7zZHCd9qCUlLxpWh0yk38TYiBsXwUVckOn8EChvvOs8M4rbXilIhaRyfvU0vh9fT00EcOvuDoV",
  // clientId: "401c3b76e3354f2e87a41b8ffbf0a233",
  documentationUrl: "https://api.fipay.io/swagger.json",
};

export default environment;
